import { render, staticRenderFns } from "./AdminAgentDashboard.vue?vue&type=template&id=35e3af54&scoped=true"
import script from "./AdminAgentDashboard.vue?vue&type=script&lang=js"
export * from "./AdminAgentDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdminAgentDashboard.vue?vue&type=style&index=0&id=35e3af54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e3af54",
  null
  
)

export default component.exports